import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  Dashboard: {
    padding: "2em 0em",
    [theme.breakpoints.down("md")]: {
      padding: "5em 0em",
    },
  },
  section: {
    backgroundColor: "#e7e7e9",
    minHeight: "100vh",
  },
  avatar: {
    width: "3em !important",
    height: "3em !important",
    borderRadius: "10px !important",
  },
  name: { fontWeight: "600 !important" },
  number: { color: "#7E8184" },
  pentagon: {
    position: "relative",
    width: "90px",
    height: "24px",
    background: "#FFC400",
    clipPath: "polygon( 50% 0, 60% 50%, 50% 100%, 0% 100%, 0 0%)",
    padding: "2px 5px",
    marginLeft: "10px",
  },
  dashboards: {
    padding: "2em",
  },
  dashboardCard: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06)",
  },
  dashboardCards: {
    padding: "1em 2em",
    [theme.breakpoints.down("sm")]: {
      padding: "1em 0.5em",
    },
  },
  headText: {
    fontSize: "18px !important",
    fontWeight: "600 !important",
    color: "#2c3e50 !important",
    marginBottom: "1rem !important",
  },
  viewAll: {
    fontSize: "14px !important",
    fontWeight: "500 !important",
    color: "#7E8184",
  },
  live: {
    color: "#07AD00",
    display: "flex",
    marginBottom: "2em !important",
    [theme.breakpoints.down("tablet")]: {
      fontSize: "15px !important",
    },
  },
  Upcoming: {
    color: "#FFC400",
    display: "flex",
    marginBottom: "2em !important",
    [theme.breakpoints.down("tablet")]: {
      fontSize: "15px !important",
    },
  },
  Past: {
    color: "#EB2D6F",
    display: "flex",
    marginBottom: "2em !important",
    [theme.breakpoints.down("tablet")]: {
      fontSize: "15px !important",
    },
  },
  my: {
    color: "#0050FF",
    display: "flex",
    marginBottom: "2em !important",
    [theme.breakpoints.down("tablet")]: {
      fontSize: "15px !important",
    },
  },
  dot: {
    width: "6px",
    height: "6px",
    color: "#07AD00",
    backgroundColor: "#07AD00",
    borderRadius: "100px",
    margin: "auto 6px auto 0px",
  },
  dot1: {
    width: "6px",
    height: "6px",
    color: "#FFC400",
    backgroundColor: "#FFC400",
    borderRadius: "100px",
    margin: "auto 6px auto 0px",
  },
  dot2: {
    width: "6px",
    height: "6px",
    color: "#EB2D6F",
    backgroundColor: "#EB2D6F",
    borderRadius: "100px",
    margin: "auto 6px auto 0px",
  },
  dot3: {
    width: "6px",
    height: "6px",
    color: "#0050FF",
    backgroundColor: "#0050FF",
    borderRadius: "100px",
    margin: "auto 6px auto 0px",
  },
  auctionCard: {
    padding: "1em",
    borderRadius: "9px",
    marginTop: "2em",
  },
  icon: {
    backgroundColor: "#fff",
    borderRadius: "100px",
    width: "1.6em",
    height: "1.6em",
    textAlign: "center",
    padding: "0px",
  },
  svg: { fontSize: "14px !important" },
  sellerSearch: {
    marginTop: "2em",
  },
  dashSearch: { position: "relative" },
  searchIcon: {
    position: "absolute",
    right: "10px",
    top: "10px",
    color: "#999999",
  },
  viewBtn: {
    padding: "8px 12px",
    cursor: "pointer",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f8f9fa",
    },
  },
  topDetail: { marginBottom: "4em" },
  SideLine: {
    borderRight: "1px solid #000",
    [theme.breakpoints.down("sm")]: {
      borderRight: "1px solid #fff !important",
    },
  },
  detailCard: {
    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
    padding: "20px",
    borderRadius: "8px",
    backgroundColor: "#fff",
  },
  marginremove: { marginBottom: "0px !important" },
  BuyEventHeading: { display: "flex", justifyContent: "space-between" },
  DataTable: {
    opacity: 1,
    "& .rdt_Table": {
      backgroundColor: "#fff",
      borderRadius: "8px",
      overflow: "hidden",
    },
    "& .rdt_TableHead": {
      backgroundColor: "#f8f9fa",
      borderBottom: "2px solid #dee2e6",
    },
    "& .rdt_TableHeadRow": {
      backgroundColor: "#f8f9fa",
      minHeight: "52px",
    },
    "& .rdt_TableCol": {
      fontWeight: "600",
      color: "#495057",
      fontSize: "14px",
    },
    "& .rdt_TableRow": {
      borderBottom: "1px solid #dee2e6",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "#f8f9fa",
      },
    },
    "& .rdt_TableCell": {
      padding: "12px 8px",
      fontSize: "14px",
      color: "#495057",
    },
  },
  ellipsisText: {
    cursor: "pointer",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  customTooltip: {
    backgroundColor: "black",
    color: "white",
  },

  // Expandable lots inside the auctions listing
  expandAllLink: {
    display: "inline-flex !important",
    alignItems: "center",
    gap: "4px",
    fontSize: "13px !important",
    fontWeight: "600 !important",
    color: "#2D55EB !important",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline !important",
    },
    "&:disabled": {
      color: "#adb5bd !important",
      cursor: "default",
    },
  },
  expandedLots: {
    padding: "12px 16px",
    backgroundColor: "#f8f9fa",
    borderBottom: "1px solid #dee2e6",
  },
  lotsHeading: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#495057",
    marginBottom: "8px",
  },
  lotsMessage: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    color: "#6c757d",
  },
  lotsTable: {
    marginBottom: "0px !important",
    backgroundColor: "#fff",
    "& th": {
      whiteSpace: "nowrap",
      fontSize: "12px",
      fontWeight: "600",
      color: "#495057",
      backgroundColor: "#eef1f5",
    },
    "& td": {
      whiteSpace: "nowrap",
      fontSize: "12px",
      color: "#495057",
      verticalAlign: "middle",
    },
  },
  lotStatusLive: {
    color: "#07AD00",
    fontWeight: "600",
  },
  lotStatusUpcoming: {
    color: "#FFC400",
    fontWeight: "600",
  },
  lotStatusEnded: {
    color: "#EB2D6F",
    fontWeight: "600",
  },

  // Enhanced form styles
  forms: {
    "& .form-control": {
      borderRadius: "6px !important",
      border: "1px solid #ced4da !important",
      padding: "0.75rem !important",
      fontSize: "14px !important",
      transition:
        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
      "&:focus": {
        borderColor: "#80bdff !important",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25) !important",
      },
    },
    "& .form-select": {
      borderRadius: "6px !important",
      border: "1px solid #ced4da !important",
      padding: "0.75rem !important",
      fontSize: "14px !important",
      "&:focus": {
        borderColor: "#80bdff !important",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25) !important",
      },
    },
  },

  label: {
    fontWeight: "600 !important",
    color: "#495057 !important",
    marginBottom: "0.5rem !important",
    fontSize: "14px !important",
  },

  input: {
    borderRadius: "6px !important",
    border: "1px solid #ced4da !important",
    padding: "0.75rem !important",
    fontSize: "14px !important",
    transition: "all 0.2s ease !important",
    "&:focus": {
      borderColor: "#80bdff !important",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25) !important",
      outline: "none !important",
    },
    "&:disabled": {
      backgroundColor: "#f8f9fa !important",
      opacity: "1 !important",
    },
  },

  saveNextBtns: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    marginTop: "2rem",
  },

  saveBtn: {
    display: "flex",
    justifyContent: "center",
    marginTop: "2rem",
  },

  pre: {
    backgroundColor: "#6c757d !important",
    color: "#fff !important",
    border: "none !important",
    borderRadius: "4px !important",
    padding: "0.5rem 1rem !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    textTransform: "none !important",
    minWidth: "100px !important",
    "&:hover": {
      backgroundColor: "#5a6268 !important",
    },
  },

  next: {
    backgroundColor: "#2D55EB !important",
    color: "#fff !important",
    border: "none !important",
    borderRadius: "4px !important",
    padding: "0.5rem 1rem !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    textTransform: "none !important",
    minWidth: "100px !important",
    "&:hover": {
      backgroundColor: "#1E3DD1 !important",
    },
  },

  // Modal enhancements
  modalMain: {
    "& .MuiModal-backdrop": {
      backgroundColor: "rgba(0, 0, 0, 0.5) !important",
    },
  },

  // Form section styling
  formSection: {
    marginBottom: "2rem",
    padding: "1.5rem",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
  },

  sectionTitle: {
    fontSize: "18px !important",
    fontWeight: "600 !important",
    marginBottom: "1.5rem !important",
    color: "#34495e !important",
    borderBottom: "2px solid #3498db",
    paddingBottom: "0.5rem",
  },

  // Enhanced button styling
  actionButton: {
    borderRadius: "6px !important",
    padding: "0.75rem 1.5rem !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    textTransform: "none !important",
    minWidth: "100px !important",
    transition: "all 0.2s ease !important",
  },

  // Error styling
  errorText: {
    color: "#dc3545 !important",
    fontSize: "12px !important",
    marginTop: "4px !important",
  },

  // Help text styling
  helpText: {
    color: "#6c757d !important",
    fontSize: "12px !important",
    marginTop: "4px !important",
    fontStyle: "italic",
  },
}));

export default useStyles;
